export default __webpack_public_path__ + "static/media/gq.604e6a58.svg";